import { defineRouter } from '#q-app/wrappers';
import { createRouter, createWebHistory } from 'vue-router';
import routes from './routes';
import { useAuthStore } from 'stores/useAuthStore';

export default defineRouter(function () {
  const Router = createRouter({
    scrollBehavior: () => ({ left: 0, top: 0 }),
    routes,
    history: createWebHistory(),
  });

  Router.onError((error, to) => {
    const chunkErrors = [
      'Failed to fetch dynamically imported module',
      'Importing a module script failed',
    ];
    if (chunkErrors.some((msg) => error.message.includes(msg))) {
      window.location.href = to.fullPath;
    }
  });

  Router.beforeEach((to) => {
    const authStore = useAuthStore();

    // Public routes that don't require authentication
    const publicRoutes = ['login', 'register'];
    const isPublicRoute = publicRoutes.includes(to.name as string);

    // If not authenticated and trying to access protected route
    if (!authStore.isAuthenticated && !isPublicRoute) {
      // Solo preservar el redirect para deep links reales; entrar a la home no
      // ensucia la URL con ?redirect=/.
      const query = to.fullPath === '/' ? {} : { redirect: to.fullPath };
      return { name: 'login', query };
    }

    // If authenticated and trying to access login/register, redirect to dashboard
    if (authStore.isAuthenticated && isPublicRoute) {
      return { name: 'dashboard' };
    }

    // Permission check via route meta.
    // RBAC is role-based (admin/alumno) — only admin routes are gated, on role.
    // All other resources (dashboard/profile/courses/learn) are available to any
    // authenticated user. The legacy permissions[] gate is removed: it always
    // returned false (permissions[] is empty), which redirected every non-admin
    // resource to dashboard — and since dashboard itself is a resource, that
    // produced an infinite "/" -> "/" redirect loop.
    if (to.meta.resource === 'admin' && authStore.userRole !== 'admin') {
      return { name: 'dashboard' };
    }

    return true;
  });

  return Router;
});
